import React from 'react'
import 'react-datepicker/dist/react-datepicker.css'
// import { externalTooltipHandler } from "./ChartUtils.js"
import getLogger from "./Logging.js"
// import {Line} from "react-chartjs-2";
import styles from "./Widget.module.css"
import {Icon} from "./FormComps";

const log = getLogger("Widget")

export function WidgetGroup(props) {
  return (
    <div style={{display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center"}}>
      {props.children}
    </div>
  )
}

export function Widget(props) {
  let containerStyles = {}
  let bodyStyles = {}
  if (props?.size) {
    containerStyles.width =
        "xl" === props.size ? (
          "400px"
        ) : "lg" === props.size ? (
          "300px"
        ) : "md" === props.size ? (
          "150px"
        ) : (
          "fit-content"
        )
  }
  if (props?.align) {
    switch (props?.align) {
      case "left":
        containerStyles.alignItems = "start"
        bodyStyles.alignItems = "start"
        break
      case "right":
        containerStyles.alignItems = "end"
        bodyStyles.alignItems = "end"
        break
      case "center":
        containerStyles.alignItems = "center"
        bodyStyles.alignItems = "center"
        break
      default:
        containerStyles.alignItems = "left"
        bodyStyles.alignItems = "left"
    }
  }
  if (props?.direction) {
    switch (props?.direction) {
      case "column":
        bodyStyles.flexDirection = "column"
        break
      default:
        bodyStyles.flexDirection = "row"
        break
    }
  }
  return (
    <div className={styles.widget + ` ${props.className ? props.className : ""} ${props.onClick ? styles.clickable : ""}`} style={containerStyles} onClick={props.onClick ? props.onClick : null}>
      {
        props.icon &&
          <Icon icon={props.icon}/>
      }
      <div className={styles.title}>{props.title}</div>
      {
        props.subtitle &&
          <div className={styles.subtitle}>
            {props.subtitle}
          </div>
      }
      <div className={styles.body} style={bodyStyles}>
        {props.children}
      </div>
    </div>                    
  )
}

export function WidgetMetric(props) {
  return (
    <div className={styles.metric} title={props.title}>
      {props.children}
    </div>
  )
}

export function WidgetMiniChart(props) {
  return (
    <div className={styles["mini-chart"]}>
      {props.children}
    </div>
  )
}

// export function WidgetMiniLineChart(props) {
//
//   const [chartOptions, setChartOptions] = useState(null)
//
//   useEffect(() => {
//     setChartOptions({
//       responsive: true,
//       plugins: {
//         legend: {
//           display: false
//         },
//         tooltip: {
//           enabled: false,
//           position: 'nearest',
//           external: externalTooltipHandler
//         }
//       },
//       scales: {
//         x: {
//           display: false,
//           beginAtZero: true,
//         },
//         y: {
//           display: false,
//           beginAtZero: true,
//         },
//       }
//     })
//   }, [])
//
//   return (
//     props.data &&
//       <div className={styles["mini-chart"]}>
//         <Line options={chartOptions} data={props.data}/>
//       </div>
//   )
// }

